export default "__VITE_ASSET__DdGe$SLM__"